__turbopack_context__.v({
  "field": "H0UdKW_field",
  "fieldDescription": "H0UdKW_fieldDescription",
  "fieldError": "H0UdKW_fieldError",
  "fieldErrorList": "H0UdKW_fieldErrorList",
  "fieldLabel": "H0UdKW_fieldLabel",
  "icon": "H0UdKW_icon",
});
